// This function does not confirm that an email address is, in fact, valid, or even
// that the address conforms to the RFC 822 spec. It simply confirms that a string
// follows the anystring@anystring.anystring pattern. True validation can be handled
// by sending a confirmation email to the address in question.
export default function isEmail(str) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(str);
}
